<template>
  <div class="MyCollect">
    <div class="collect-box">
      <div class="nav">
        <p class="nav-title">内容分类</p>
        <el-collapse>
          <el-collapse-item>
            <template slot="title">
              <i class="el-icon-caret-right" style="padding-right: 10px"></i>
              全部
            </template>
            <p @click="ChangText = 1" :class="{ cur: ChangText === 1 }">近一周</p>
            <p @click="ChangText = 2" :class="{ cur: ChangText === 2 }">近一个月</p>
            <p @click="ChangText = 3" :class="{ cur: ChangText === 3 }">近三个月</p>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="collect-list">
        <div class="collect-title">
          <img src="../../../assets/img/reader/basics.png" alt="" />
          <span>我的收藏</span>
        </div>
        <el-table :data="tableData.list || []" style="width: 100%">
          <el-table-column prop="bookInfo" label="题名" width="200">
            <template slot-scope="scope">
              {{ scope.row.bookInfo.title.toString()}}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="收藏时间" width="140">
            <template slot-scope="scope">
              {{ $store.getters.unixTime(scope.row.createTime).substring(0, 9) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template v-slot="{ row }">
              <el-button @click="detailsBtn(row)">查看详情</el-button>
              <el-button @click="cancelBtn(row)">取消收藏</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="ranking-list">
      <div class="ranking-title">书籍排行榜</div>
       <template v-if="!booksList || booksList.length <= 0">
          <p style="color: #909399;line-height: 60px;text-align: center;">暂无数据</p>
        </template>
      <div class="book-list" v-for="(item, index) in booksList" :key="index" v-if="index < 6" >
        <div style="display: flex;" >
          <div class="img" v-if="item.coverPic"
          :style="'background: url('+ item.coverPic +') no-repeat top center /cover'"></div>
          <p class="book-title" >{{toStr(item.bookName)}}</p>
        </div>
        <div class="details" @click="detailsBtn(item)">查看详情</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  listCollection,
  deleteCollectionById,
  getCollectionOrder,
} from "@/utils/router/reader.api";
export default {
  data() {
    return {
      ChangText: 0,
      tableData: [],
      booksList: [],
      picUrl: '../../../assets/img/reader/04.png',
    };
  },
  methods: {
    toStr(val) {
      return val ? val.toString() : '无'
    },
    showBtn() {
      this.isShow = true;
    },
    detailsBtn(row,item) {
      this.$router.push({
        path: "/detail",
        query: {
          key: this.$UrlEncode.encode(JSON.stringify({
            bookId: row.bookId || item.bookId
          }))
        }
      })
    },
    // 取消
    cancelBtn(row) {
      deleteCollectionById({
        userId: this.$store.state.userInfo.userId,
        bookId: row.bookId,
      }).then((res) => {
        if (res && res.data.code === 200) {
          this.$alert("取消成功");
          this.getMyCollect()
        } else {
          this.$alert(res.data.message);
        }
      });
    },
    getMyCollect() {
      listCollection({
        userId: this.$store.state.userInfo.userId,
        typeId: this.$store.state.typeId,
      }).then((res) => {
        if (res && res.data.code === 200) {
          this.tableData = res.data.data || [];
        }
      });
    },
    getCollect() {
      getCollectionOrder({typeId: this.$store.state.typeId,}).then(res=> {
       if (res && res.data.code === 200) {
         this.booksList = res.data.data
         this.booksList = this.booksList.map(data => {
           if(!data.coverPic || data.coverPic == '/') {
              data.coverPic = '/frontend/img/default.jpg'
           }
           return data
         })
       }
     })
    },
  },
  created() {
    this.getCollect()
    this.getMyCollect()
  }
};
</script>

<style lang="less" scoped>
.MyCollect {
  margin-bottom: 56px;
  display: flex;
  .collect-box {
    border: 1px solid #dcdcdc;
    box-shadow: 0px 4px 7px 0px rgba(6, 0, 1, 0.1);
    display: flex;
    flex: 1;
    .nav {
      width: 290px;
      border-right: 2px solid #d9dce0;
      font-size: 20px;
      font-weight: bold;
      padding: 8px 6px;
      .nav-title {
        height: 84px;
        border-bottom: 2px solid #d9dce0;
        color: #654719;
        line-height: 84px;
        padding-left: 96px;
      }
      /deep/.el-collapse-item__header {
        height: 72px;
        font-size: 20px;
        font-weight: bold;
        padding-left: 94px;
      }
      /deep/.el-collapse-item__header.is-active {
        background-color: #efece8;
        color: #654719;
      }
      /deep/.el-collapse-item__content {
        min-height: 600px;
        padding-bottom: 0;
        p {
          font-size: 20px;
          font-weight: bold;
          cursor: pointer;
          line-height: 66px;
          padding-left: 102px;
        }
      }
      /deep/.el-collapse-item__arrow {
        display: none;
      }
    }
    .collect-list {
      font-size: 20px;
      font-weight: bold;
      flex: 1;
      padding-top: 8px;
      padding-right: 32px;
      .collect-title {
        height: 84px;
        border-bottom: 2px solid #d9dce0;
        color: #654719;
        line-height: 84px;
        padding-left: 32px;
        img {
          position: relative;
          top: 12px;
        }
      }
      /deep/.el-table tr {
        height: 72px;
        color: #242424;
        font-size: 20px;
        font-weight: bold;
      }
      .el-button {
        width: 74px;
        height: 30px;
        border: 1px solid #654719;
        color: #654719;
      }
    }
  }
  .ranking-list {
    width: 342px;
    border: 1px solid #dcdcdc;
    box-shadow: 0px 4px 7px 0px rgba(6, 0, 1, 0.1);
    margin-left: 24px;
    padding: 0 8px;
    .ranking-title {
      height: 99px;
      border-bottom: 10px solid #846c47;
      color: #654719;
      font-size: 20px;
      font-weight: bold;
      padding: 32px 0 26px 106px;
    }
    .book-list {
      height: 124px;
      border-bottom: 2px solid #d9dce0;
      font-size: 18px;
      margin-bottom: 8px;
      padding: 10px 16px;
      .img {
        width: 78px;
        height: 100px;
      }
      .book-title {
        height: 60px;
        color: #343434;
        margin-left: 12px;
        letter-spacing: 1px;
        line-height: 30px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .details {
        cursor: pointer;
        position: relative;
        top: -22px;
        left: 158px;
      }
    }
  }
  .cur {
    background-color: #efece8;
    color: #654719;
    cursor: pointer;
    margin-top: 2px;
  }
}
</style>
